var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("googlePlay.apps"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    _vm.showAddModal = true
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "16px", "margin-right": "4px" },
                  },
                  [_vm._v("add")]
                ),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("googlePlay.addApp")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { loading: _vm.loading }, on: { click: _vm.fetchApps } },
              [
                _c("a-icon", { attrs: { type: "reload" } }),
                _vm._v(
                  " " + _vm._s(_vm.$t("googlePlay.refresh")) + "\n            "
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "apps-container gpr-app-list" },
            _vm._l(_vm.apps, function (app) {
              return _c(
                "article",
                { key: app._id, staticClass: "gpr-app-list__card" },
                [
                  _c("div", { staticClass: "gpr-app-list__main" }, [
                    _c("div", { staticClass: "gpr-app-list__icon" }, [
                      app.iconUrl
                        ? _c("img", { attrs: { src: app.iconUrl, alt: "" } })
                        : _c("span", { staticClass: "material-icons" }, [
                            _vm._v("android"),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "gpr-app-list__info" }, [
                      _c("h3", { staticClass: "gpr-app-list__name" }, [
                        _vm._v(_vm._s(app.appName)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "gpr-app-list__package" }, [
                        _vm._v(_vm._s(app.packageName)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "gpr-app-list__meta" }, [
                        app.totalReviewCount
                          ? _c("span", { staticClass: "gpr-app-list__badge" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("reviews"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(app.totalReviewCount) + " reviews"
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        app.lastSyncedAt
                          ? _c("span", { staticClass: "gpr-app-list__badge" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("sync"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formatDate(app.lastSyncedAt))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "gpr-app-list__actions" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            loading: _vm.syncingApp === app._id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.syncReviews(app)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "sync" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("googlePlay.syncReviews")) +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "gpr-app-list__btn-remove",
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmRemove(app)
                            },
                          },
                        },
                        [_c("a-icon", { attrs: { type: "delete" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _c("div", { staticClass: "loading" }, [_c("a-spin")], 1),
      _vm._v(" "),
      !_vm.loading && _vm.apps.length === 0
        ? _c(
            "div",
            { staticClass: "empty" },
            [
              _c(
                "a-empty",
                { attrs: { description: _vm.$t("googlePlay.noAppsFound") } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showAddModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("googlePlay.addApp")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("googlePlay.addApp"),
            "confirm-loading": _vm.adding,
          },
          on: { ok: _vm.addApp },
          model: {
            value: _vm.showAddModal,
            callback: function ($$v) {
              _vm.showAddModal = $$v
            },
            expression: "showAddModal",
          },
        },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t("googlePlay.packageName"),
                required: true,
              },
            },
            [
              _c("a-input", {
                attrs: { placeholder: "com.example.myapp" },
                model: {
                  value: _vm.newApp.packageName,
                  callback: function ($$v) {
                    _vm.$set(_vm.newApp, "packageName", $$v)
                  },
                  expression: "newApp.packageName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("googlePlay.appName"), required: true } },
            [
              _c("a-input", {
                attrs: { placeholder: _vm.$t("googlePlay.appNamePlaceholder") },
                model: {
                  value: _vm.newApp.appName,
                  callback: function ($$v) {
                    _vm.$set(_vm.newApp, "appName", $$v)
                  },
                  expression: "newApp.appName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("googlePlay.iconUrl") } },
            [
              _c("a-input", {
                attrs: { placeholder: "https://..." },
                model: {
                  value: _vm.newApp.iconUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.newApp, "iconUrl", $$v)
                  },
                  expression: "newApp.iconUrl",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("googlePlay.removeApp"), "ok-type": "danger" },
          on: { ok: _vm.removeApp },
          model: {
            value: _vm.removeModal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.removeModal, "visible", $$v)
            },
            expression: "removeModal.visible",
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("googlePlay.removeAppConfirm", {
                  name: _vm.removeModal.app ? _vm.removeModal.app.appName : "",
                })
              )
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }